// Copy Link
function copyLink() {
  var inputc = document.body.appendChild(document.createElement("input"));
  inputc.value = window.location.href;
  inputc.focus();
  inputc.select();
  document.execCommand('copy');
  inputc.parentNode.removeChild(inputc);
}

$('.copy-link').click(function(e) {
  e.preventDefault();
  copyLink();
  return false;
});
